import apiUrl from '../config/apiUrl';
import fetchUrl from '../utils/fetchUrl';

export const CURRENCY_FIND_ALL = async (currencyType?: string) => {
  let url;
  if (!currencyType) {
    url = `${apiUrl}core/currency/find-all`;
  } else {
    url = `${apiUrl}core/currency/find-all?currencyType=${currencyType}`;
  }
  return await fetchUrl({
    url,
    method: 'GET',
  });
};
export const CURRENCY_FIND_ONE_BY_NAME = async (symbol: string) => {
  return await fetchUrl({
    url: `${apiUrl}core/currency/find-one-by-name?name=${symbol}`,
    method: 'GET',
    body: {},
  });
};
export const SYMBOL_FIND_ALL = async () => {
  return await fetchUrl({
    url: `${apiUrl}core/symbol/find-all`,
    method: 'GET',
  });
};
